<template>
  <div :ref="'linechart_' + stamp" style="width: 100%; height: 100%"></div>
</template>

<script>
import $pubsub from "../utils/pubsub.js";
export default {
  name: "line-chart",
  data() {
    return {
      stamp: Date.now(),
      option: {},
      myChart: null
    };
  },
  props: ["name", "move", "time"],
  mounted() {
    this.$nextTick(() => {
      this.updateOption();
      this.loaddata();
    });
  },
  watch: {
    move: {
      handler(val) {
        if(val) {
          this.updateOption();
          this.$nextTick(() => {
            this.loaddata();
          });
        }
      }
    },
    time: {
      handler(val) {
        if(val) {
          this.myChart.resize();
        }
      }
    },
  },
  methods: {
    loaddata() {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
      };
      this.myChart = this.$echarts.init(this.$refs["linechart_" + this.stamp]);
      this.myChart.setOption({ ...option, ...this.option });
    },
    updateOption() {
      const store = $pubsub();
      const id = Number(this.name.split("_")[1]);
      const modal = store.getter("modals").find((item) => item.id === id);
      const option = store.getter("options")[modal.optionName];
      this.option = option ? option : {};
    }
  },
};
</script>
